/**
 * Copyright (c) 2021
 *
 * Handle low level logic to store impersonate data
 *
 * @summary
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2021-08-20 10:21:56
 * Last modified  : 2021-08-20 16:32:32
 */

class ImpersonateService {

    static get KEY() { return 'SWITCH_TO_CUSTOMER_EMAIL'; }

    /**
     * @returns null|String
     */
    get emailToSwitch () {
        return localStorage.getItem(ImpersonateService.KEY)
    }

    /**
     * @param email null|String
     * @returns void
     */
    set emailToSwitch (email) {
        if (email !== null) {
            localStorage.setItem(ImpersonateService.KEY, email)
        } else {
            localStorage.removeItem(ImpersonateService.KEY)
        }
    }

    /**
     * @returns Boolean
     */
    get isCustomerSwitched () {
        return this.emailToSwitch !== null
    }
}

export default new ImpersonateService()
